import { eTipoPermissao } from '@/enums/ePermissoes';
export default [
  {
    description: 'Paralisações/Recessos',
    path: '/calendario/paralisacoes/:calendarioId?/:ensinoId?',
    name: 'calparalisacoes',
    component: () => import('@/views/calendario/paralisacao/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.PARALISACOESNOVO_MENU_200300299],
    },
    goesToMenu: true,
    props: true,
  },
];
